import MessageBox from './message-box/index.js'
import GTableContent from './global/GTableContent.vue';

const components = [
  GTableContent
]

export default function install(Vue) {
  Vue.prototype.$msgbox = MessageBox
  Vue.prototype.$alert = MessageBox.alert
  Vue.prototype.$confirm = MessageBox.confirm
  Vue.prototype.$prompt = MessageBox.prompt
  components.map(component => {
    Vue.component(component.name, component)
  })
}
